export type { DetailInfoListItemProps } from "./detail-info-list-item";
export { DetailInfoListItem } from "./detail-info-list-item";
